import React, {Component} from "react";
import {getUserOrganizations} from "../../../modules/user";

import "./facility-filter.css";

class FacilityFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            facilities: []
        }
    }
    
    async componentDidMount() {
        let {token} = this.props;
        let organizationsResponse = await getUserOrganizations(token);

        if (organizationsResponse.data.success) {
            let organizations = organizationsResponse.data.organizations;
            this.setState({facilities: organizations});
        }
    }

    onChange(e) {
        let {handle_facility_filter_change} = this.props;
        
        let newValue = e.target.value;

        handle_facility_filter_change(newValue);
    }

    render() {
        let {facilities} = this.state;

        return (
            <div className='facility_filter_container'>
                <label className="facility_filter_label">Filter by Facility:</label>
                <select onChange={this.onChange.bind(this)} className="facility_filter_select">
                    <option value="-1">Show All</option>
                    {facilities.map((facility) => {
                        return (<option value={facility.id}>{facility.name}</option>);
                    })}
                </select>
            </div>
        )
    }
}

export default FacilityFilter;


// WEBPACK FOOTER //
// ./src/components/containers/metabase-dashboard/facility-filter.js